const ROOT_PATH = '/daily-tasks' as const;

export const ROOT = {
  PATH: ROOT_PATH,
  toPath: () => ROOT_PATH,
};
